import { Alert, Card, InProgress, Leaf, Typography } from '@sonnen/web-ui';
import { parseHtmlTags } from '@sonnen/web-utils';
import { useAppContext } from '../../../AppContext/AppContext';
import SmartMeterDE from '../../../assets/images/SmartMeter_De.webp';
import SmartMeterEng from '../../../assets/images/SmartMeter_Eng.webp';
import CardImage from '../../../components/CardImage/CardImage';
import { CustomUSPCard } from '../../../components/CustomUSPCard/CustomUSPCard';
import OptimizationInfoCard from '../../../components/OptimizationInfoCard/OptimizationInfoCard';
import { useTranslation } from '../../../i18n/i18n';
import { useOfferContext } from '../../../OfferContext/OfferContext';
import { ModuleName } from '../../../types';
import { moduleAvailable } from '../../../utils/utils';
import { ChartsContainer } from '../ChartsContainer/ChartsContainer';
import styles from './EnergyDynamicOverview.module.css';

const EnergyDynamicOverview = () => {
  const { t, language } = useTranslation();
  const { user } = useAppContext();
  const { offer } = useOfferContext();
  const available = moduleAvailable(offer, ModuleName.PRICE_OPTIMIZATION);
  const smartMeterRequired = available || !user;

  return (
    <div data-testid="energyDynamic-overview">
      <CustomUSPCard i18nScope="home.cardChart">
        <ChartsContainer />
      </CustomUSPCard>

      <OptimizationInfoCard />

      <div className={styles.statusContainer}>
        <Card className={styles.greenCard}>
          <Leaf color="success" size="xl" />
          <Typography.H3 variant="success">{t('optimizationInfoCard.greenCard')}</Typography.H3>
        </Card>
        <Card className={styles.blueCard}>
          <InProgress color="interactive" size="xl" />
          <Typography.H3 variant="interactive">{t('optimizationInfoCard.blueCard')}</Typography.H3>
        </Card>
      </div>

      <CustomUSPCard i18nScope="home.cardSmartMeter">
        <CardImage
          src={language == 'de' ? SmartMeterDE : SmartMeterEng}
          dataTestId="smart-meter"
          className={styles.smartMeterImg}
        />
      </CustomUSPCard>

      {smartMeterRequired && (
        <Card paddingSize="none">
          <Alert title={t('modules.priceOptimization.smartMeterInfo.title')}>
            {parseHtmlTags(t('modules.priceOptimization.smartMeterInfo.content'))}
          </Alert>
        </Card>
      )}
    </div>
  );
};
export default EnergyDynamicOverview;
